import DEFConfig from '@/config/defaults';
import AMSConfig from '@/config/amsterdam';
import PNCConfig from '@/config/park-n-charge';
import GRNConfig from '@/config/groningen';
import OPCConfig from '@/config/opcharge';
import VLAConfig from '@/config/vlaanderen';
import RVBConfig from '@/config/rvb';
import ENGConfig from '@/config/engie';

import i18n from '@/plugins/i18n';

/******************************************************************************
 * Select and export the Config of the active tenant
 */
const ConfigByTenant = {
  amsterdam: AMSConfig,
  opcharge: OPCConfig,
  'park-n-charge': PNCConfig,
  vlaanderen: VLAConfig,
  rvb: RVBConfig,
  groningen: GRNConfig,
  engie: ENGConfig
};

export const Config = Object.assign(DEFConfig, ConfigByTenant[process.env.VUE_APP_TENANT] || {});

export const chargePointOperatorField = Config.chargePointOperatorField;
export const DateOfCommissioningFields = Config.DateOfCommissioningFields;
export const stepComponents = Config.stepComponents || {};
export const dataLayers = Config.dataLayers || {};

export const visibleRequestsByRealisationStatuses = Config.visibleRequestsByRealisationStatuses;

export const benchmarkMenu = Config.benchmarkMenu;
export const gridConnectionValues = Config.gridConnectionValues;
export const assetManagementFields = Config.assetManagementFields;
export const exportCsv = Config.exportCsv;
export const canResetDateValue = Config.canResetDateValue;
export const requestMapShowActiveRedMarker = Config.requestMapShowActiveRedMarker;
export const preparationDateFields = Config.preparationDateFields;
export const parkinglotSearch = Config.parkinglotSearch;
export const realisationListFields = Config.realisationListFields;
export const defaultRealisationTableFields = Config.defaultRealisationTableFields;
export const defaultPrivateTableFields = Config.defaultPrivateTableFields;
export const defaultRealisationStatusFilters = Config.defaultRealisationStatusFilters;
export const generateFullAddress = Config.generateFullAddress;

export const defaultRowsPerPageOptions = Config.defaultRowsPerPageOptions;
export const defaultRowsPerPage = Config.defaultRowsPerPage;

export const finUnit = Config.finUnit;
export const useStreetCabinetUploadField = Config.useStreetCabinetUploadField;
export const tour = Config.tour;
// Genrally uses default menu
export const AdminMenu = Config.AdminMenu || [];
export const ReportingMenu = Config.ReportingMenu || [];

export const LocationPickerDiameter = Config.LocationPickerDiameter || 200; // meters
export const RegionalProjectLeaders = Config.RegionalProjectLeaders || [];
/******************************************************************************
 * Helper methods
 */
export const roleToRoleLabel = role => {
  if (role?.includes(':')) {
    const [category, partyRole] = role.split(':');
    const partyRoleLabel = i18n.te(`ProfileCard.partyRoles.${partyRole}`)
      ? i18n.t(`ProfileCard.partyRoles.${partyRole}`)
      : partyRole;
    return `${roleToRoleLabel(category)} (${partyRoleLabel})`;
  }
  switch (role) {
    case 'cpo':
      return i18n.t('ProfileCard.userRoles.cpo');
    case 'municipality':
      return i18n.t('ProfileCard.userRoles.municipality');
    case 'admin':
      return i18n.t('ProfileCard.userRoles.admin');
    case 'caseworker':
      return i18n.t('ProfileCard.userRoles.caseworker');
    case 'customer':
      return i18n.t('ProfileCard.userRoles.customer');
    case 'guest':
    case 'caseviewer':
      return i18n.t('ProfileCard.userRoles.guest');
    case 'gridoperator':
      return i18n.t('ProfileCard.userRoles.gridoperator');
    case 'dso':
      return i18n.t('ProfileCard.userRoles.dso');
    case 'contractor':
      return i18n.t('ProfileCard.userRoles.contractor');
    case 'region':
      return i18n.t('ProfileCard.userRoles.region');
  }
  return '';
};
